import { PDFDownloadLink } from '@react-pdf/renderer';
import styled, { css } from 'styled-components';
import { colors } from '@omilia/theme';

const shadowXl = `0 8px 8px -4px rgba(16, 24, 40, ${8 /
  255}), 0 20px 24px -4px rgba(16, 24, 40, ${32 / 255})`;

const menuRow = css`
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 12px;
  min-height: 45px;
  padding: 12px;
  text-align: left;
  text-decoration: none;
  width: 100%;

  &:hover {
    background: ${colors.COLOR_GREY_100};
  }
`;

const menuRowDestructive = css`
  ${menuRow}

  &:hover {
    background: ${colors.COLOR_RED_100};
  }
`;

export const SDivider = styled.div`
  background: ${colors.COLOR_GREY_300};
  flex-shrink: 0;
  height: 1px;
  width: 100%;
`;

export const SMenuEndChatItem = styled.button`
  ${menuRowDestructive}
`;

export const SMenuEndChatText = styled.span`
  color: ${colors.COLOR_RED_800};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
`;

export const SMenuItem = styled.button`
  ${menuRow}
`;

export const SMenuItemGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const SMenuItemText = styled.span`
  color: ${colors.COLOR_GREY_1000};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
`;

export const SMenuOverlay = styled.div<{ $isOpen: boolean }>`
  background: ${colors.COLOR_WHITE};
  border: 1px solid ${colors.COLOR_GREY_300};
  border-radius: 8px;
  box-shadow: ${shadowXl};
  box-sizing: border-box;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  flex-direction: column;
  gap: 8px;
  min-width: 180px;
  overflow: hidden;
  padding: 8px;
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 10;
`;

export const STranscriptLink = styled(PDFDownloadLink)`
  ${menuRow}
`;

export const STranscriptInner = styled.span`
  align-items: center;
  display: flex;
  gap: 12px;
  width: 100%;
`;
